var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success flex-item",attrs:{"type":"button"},on:{"click":_vm.download}},[_c('em',{staticClass:"fa fa-cloud-download-alt"}),_vm._v("\n  Download\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }